module.exports = __webpack_public_path__ + "static/media/OilChange.b7ebb3fa.svg";